import { Box, Image } from '@domain-group/suit-theme'

import type { AttachmentModel } from '@models/attachment'

import DownloadButton from './DownloadButton'
import Outdated from './Outdated'

interface AttachmentParams {
  attachment: AttachmentModel,
  outdated?: boolean,
}

const Attachment = (params: AttachmentParams) => {
  const { attachment, outdated } = params

  const {
    dimensions,
    file_content_type: contentType,
    links,
  } = attachment

  if (contentType?.match(/image/) && dimensions && links){
    const imageUrl = links?.thumb_url

    return (
      <Box
        border="1px solid"
        borderColor="lineColor"
        borderRadius="5px"
        marginTop="medium"
        width="fit-content"
      >
        <Box
          position="relative"
          borderRadius={outdated ? 'inherit' : '5px'}
          height={90}
          width={90}
          overflow="hidden"
        >
          <Image height="100%" url={imageUrl} />

          {outdated && (
            <Outdated />
          )}
        </Box>
      </Box>
    )
  }

  if (links) return <DownloadButton links={links} />

  return null
}

export default Attachment
